var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("label", [
          _vm._v("Select a study:\n        "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected_study,
                  expression: "selected_study",
                },
              ],
              staticStyle: { width: "20em" },
              attrs: { disabled: _vm.gwas_tracks.length === 0 },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selected_study = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v("(none selected)"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.gwas_tracks, function (ref) {
                var filename = ref.filename
                var display_name = ref.display_name
                return _c(
                  "option",
                  { key: filename, domProps: { value: filename } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          display_name === filename
                            ? display_name
                            : display_name + " ({" + filename + ")"
                        ) +
                        "\n          "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    !_vm.selected_study ? _c("p", [_vm._m(0)]) : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-info float-right",
            attrs: { disabled: !_vm.selected_study },
            on: { click: _vm.exportCSV },
          },
          [_vm._v("Download")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("tabulator-table", {
            attrs: {
              columns: _vm.table_config,
              "initial-sort": [{ column: "assoc:log_pvalue", dir: "desc" }],
              table_data: _vm.table_data,
              height: "500px",
              placeholder:
                "No data available for selected study in the specified region",
            },
            on: {
              connected: function ($event) {
                _vm.table = $event
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { color: "red" } }, [
      _c("i", [
        _vm._v('Please select a GWAS dataset to use the "export" feature.'),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }